import React from "react";
import PictureUploadField from "../../PictureUploadField/PictureUploadField";
import qfStyles from "./ClientQuickForm.module.css";
import i18n from "../../../Services/i18n";
import RichEditor from "../../RichEditor/RichEditor";
import { addToast } from "../../../Services/toastService";

class ClientQuickForm extends React.Component {
  constructor(props) {
    super(props);
    this.pictureUploadFieldRef = React.createRef();

    this.initialState = {
      firstName: "",
      lastName: "",
      email: "",
      address: "",
      companyName: "",
      phone: "",
      description: "",
    };

    this.state = {
      ...this.initialState,
    };
  }

  handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    this.setState({
      [name]: type === "checkbox" ? checked : value,
    });
  };

  isDirty = () => {
    const pictureFieldData = this.pictureUploadFieldRef.current?.getData?.();
    const hasPicture = !!pictureFieldData?.fileId;

    const hasTextValue = Object.values(this.state).some((value) => {
      if (typeof value !== "string") return false;
      return value.trim() !== "";
    });

    return hasTextValue || hasPicture;
  };

  validate = () => {
    const EMAIL_RGX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (
      this.state.firstName === "" &&
      this.state.lastName === "" &&
      this.state.companyName === ""
    ) {
      addToast(i18n.t("ClientForm.Validation.NameRequired"), "clientFormValidationName", "ERROR");
      return false;
    }

    if (this.state.email !== "" && !EMAIL_RGX.test(this.state.email)) {
      addToast(i18n.t("ClientForm.Validation.InvalidEmail"), "clientFormValidationEmail", "ERROR");
      return false;
    }

    if (this.state.description.length > 40000) {
      addToast(
        i18n.t("ClientForm.Validation.InvalidDescriptionLen"),
        "clientFormValidationEmail",
        "ERROR",
      );
      return false;
    }

    return true;
  };

  getFormData = () => {
    const pictureFieldData = this.pictureUploadFieldRef.current.getData();
    return {
      ...this.state,
      defaultImageId: pictureFieldData.fileId,
    };
  };

  render() {
    return (
      <div className={qfStyles.container}>
        <div className={qfStyles.content}>
          <div className={qfStyles.leftSection}>
            <div className={qfStyles.inlineRow}>
              <div className={qfStyles.fieldBlock}>
                <label>{i18n.t("ClientQuickForm.FieldFirstName")}</label>
                <input
                  type="text"
                  name="firstName"
                  className={qfStyles.inputMedium}
                  value={this.state.firstName}
                  maxLength={200}
                  onChange={this.handleChange}
                />
              </div>
              <div className={qfStyles.fieldBlock}>
                <label>{i18n.t("ClientQuickForm.FieldLastName")}</label>
                <input
                  type="text"
                  name="lastName"
                  className={qfStyles.inputMedium}
                  value={this.state.lastName}
                  maxLength={200}
                  onChange={this.handleChange}
                />
              </div>
            </div>

            <div className={qfStyles.inlineRow}>
              <div className={qfStyles.fieldBlock}>
                <label>{i18n.t("ClientQuickForm.FieldPhone")}</label>
                <input
                  type="text"
                  name="phone"
                  className={qfStyles.inputSmall}
                  value={this.state.phone}
                  maxLength={45}
                  onChange={this.handleChange}
                />
              </div>
              <div className={qfStyles.fieldBlock}>
                <label>{i18n.t("ClientQuickForm.FieldCompanyName")}</label>
                <input
                  type="text"
                  name="companyName"
                  className={qfStyles.inputLarge}
                  value={this.state.companyName}
                  maxLength={200}
                  onChange={this.handleChange}
                />
              </div>
            </div>

            <div className={qfStyles.inlineRow}>
              <div className={qfStyles.fieldBlock}>
                <label>{i18n.t("ClientQuickForm.FieldEmail")}</label>
                <input
                  type="text"
                  name="email"
                  className={qfStyles.inputLarge}
                  value={this.state.email}
                  maxLength={1000}
                  onChange={this.handleChange}
                />
              </div>
              <div className={qfStyles.fieldBlock}>
                <label>{i18n.t("ClientQuickForm.FieldAddress")}</label>
                <input
                  type="text"
                  name="address"
                  className={qfStyles.inputLarge}
                  value={this.state.address}
                  maxLength={400}
                  onChange={this.handleChange}
                />
              </div>
            </div>

            <div>
              <label className={qfStyles.descriptionSection}>
                {i18n.t("ClientQuickForm.FieldDescription")}
              </label>

              <RichEditor
                controlled
                value={this.state.description}
                onChange={(html) => {
                  this.setState({ description: html });
                }}
                placeholder={""}
                height={300}
                showEmoji
                showTextColor
                showFontSize
                showBold
                showItalic
                showUnderline
                showStrikethrough
              />
            </div>
          </div>

          <div className={qfStyles.rightSection}>
            <PictureUploadField ref={this.pictureUploadFieldRef} />
          </div>
        </div>
      </div>
    );
  }
}

export default ClientQuickForm;
